///chatbot/interact
export const CHATBOT_INTERACT = "CHATBOT_INTERACT";
export const CHATBOT_INTERACT_SUCCESS = "CHATBOT_INTERACT_SUCCESS";
export const CHATBOT_INTERACT_FAILURE = "CHATBOT_INTERACT_FAILURE";

///chatbot/voicetotext
export const CHATBOT_VOICETOTEXT = "CHATBOT_VOICETOTEXT";
export const CHATBOT_VOICETOTEXT_SUCCESS = "CHATBOT_VOICETOTEXT_SUCCESS";
export const CHATBOT_VOICETOTEXT_FAILURE = "CHATBOT_VOICETOTEXT_FAILURE";
